<template>
  <div class="login-container">
    <div class="login-box">
      <h2>用户登录</h2>
      <div class="input-group">
        <input type="text" v-model="username" placeholder="请输入用户名">
        <input type="password" v-model="password" placeholder="请输入密码">
      </div>
      <button class="login-btn" @click="handleLogin">登 录</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import axios from 'axios';

export default {
  name: 'UserLogin',
  data() {
    return {
      username: '',
      password: '',
      userInfo: []
    }
  },
  mounted() {
    this.getUserInfo();
  },
  computed: {
    ...mapState(['username']),
    ...mapGetters(['isLoggedIn'])
  },
  methods: {
    ...mapActions(['loginUser']),
    
    async getUserInfo() {
      try {
        const response = await axios.get('/api/userInfo.json');
        this.userInfo = response.data;
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
    handleLogin() {
      let isLogin = false;
      for (let i = 0; i < this.userInfo.length; i++) {
        if (this.username === this.userInfo[i].username && 
            this.password === this.userInfo[i].password) {
          this.loginUser(this.username);
          this.$emit('login-success');
          isLogin = true;
          break;
        }
      }
      
      if (!isLogin) {
        alert('用户名或密码错误');
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background-color: #e8f4ff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  padding-top: 20vh;
}

.login-box {
  width: 90%;
  max-width: 400px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(149, 157, 165, 0.2);
  margin-bottom: 20vh;
}

h2 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}

input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e7ff;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

input:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.login-btn {
  width: 100%;
  padding: 12px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-btn:hover {
  background-color: #357abd;
}

@media screen and (max-height: 600px) {
  .login-container {
    padding-top: 10vh;
  }
  
  .login-box {
    margin-bottom: 10vh;
  }
}
</style>
